'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_Component) {
    _inherits(Image, _Component);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _initialiseProps.call(_this);

        return _this;
    }

    return Image;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.componentDidMount = function () {
        _this2.imageElement.src = _this2.props.src;
        if (_this2.imageElement.complete && !_this2.imageElement.naturalWidth) {
            _this2.fixImage(_this2.imageElement);
        }
        _this2.forceUpdate();
    };

    this.fixImage = function (target) {
        target.src = _this2.props.backupImage;
    };

    this.render = function () {
        var props = (0, _assign2.default)({}, _this2.props);
        delete props.backupImage; //React does not recognize the `backupImage` prop on a DOM element
        var roleHelper = !props.role && !props.alt ? { role: 'presentation' } : {};
        return _react2.default.createElement('img', _extends({}, props, {
            ref: function ref(img) {
                _this2.imageElement = img;
            },
            src: props.src, alt: props.alt,
            onError: function onError(e) {
                return _this2.fixImage(e.target);
            }
        }, roleHelper));
    };
};

Image.propTypes = {
    src: _propTypes2.default.string,
    alt: _propTypes2.default.string,
    backupImage: _propTypes2.default.string
};

Image.defaultProps = {
    src: null,
    alt: null,
    backupImage: null
};

exports.default = Image;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/Image/image.js
// module id = 78
// module chunks = 0